/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const itemCategories = createSlice({
    name: 'itemCategories',
    initialState: initialState,
    reducers: {
        setItemCategories: (state, action) => {
            return action.payload;
        },
        resetItemCategories: () => {
            return initialState;
        },
    },
});

export const { setItemCategories, resetItemCategories } = itemCategories.actions;
export default itemCategories.reducer;
